module.exports = __webpack_public_path__ + "img/b9a7ce37bc0bc69a97858ab6c518798b.b5c816ef.jpg";